/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs */

const en_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group B Text`)
};

const fr_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte du groupe B`)
};

const de_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text der Gruppe B`)
};

const it_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo del gruppo B`)
};

const ru_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст группы B`)
};

const es_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto del Grupo B`)
};

const zh_cn2_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B组文本`)
};

const ja_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループBテキスト`)
};

const hi_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह बी पाठ`)
};

const pt_pt2_compare_event_groups_csv_group_b_text_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto do Grupo B`)
};

/**
* | output |
* | --- |
* | "Group B Text" |
*
* @param {Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_b_text_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_B_Text_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "de") return de_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "it") return it_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "es") return es_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_group_b_text_header(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_group_b_text_header(inputs)
	return en_compare_event_groups_csv_group_b_text_header(inputs)
});